import * as React from "react";

import { IFancyDropdownOptionProps } from "./FancyDropdownOption";
import { FancyDropdownOptions } from "./FancyDropdownOptions";

export interface IFancyDropdownTextModePrompt {
  itemID?: string;
  text: string;
  numOptions: number;
  tabIndex?: number;
  toolTip?: string;
  onFocussed?: (itemID: string) => any;
}

export const FancyDropdownTextModePrompt = (props: IFancyDropdownTextModePrompt) => {

  let text = props.text;
  if (text.trim() === "") { text = "(blank)"; }
  if (text.length >= 18) { text = text.substring(0, 15) + "..."; }

  let toolTip = null;
  if (props.toolTip) { toolTip = props.toolTip.trim(); }

  const onFocus = () => { if (props.onFocussed) { props.onFocussed(props.itemID); } };

  const onClicked = (event) => { event.preventDefault(); };

  const ariaControls = "options_" + props.itemID;

  return (
    <a className="CAL-dropdownButton CAL-button js-nav-system__link fd_default" href="#!" tabIndex={props.tabIndex} onFocus={onFocus} onClick={onClicked} aria-haspopup="true" aria-controls={ariaControls} data-tooltip={toolTip}>
      {text + " "}
      {props.numOptions > 0 &&
        <em className="fa fa-sort" aria-hidden="true"></em>
      }
    </a>
  );

};
